import { BenefitTypeEnum } from "v2/domain/common/entities/BenefitType";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import customBenefitImage from "../../../../../assets/img/v2/custom-benefit.png";
import BenefitCard from "../../BenefitCard";
import { CountryIsoCode } from "../../../../../v2/domain/common/enums/CountryISOCode";
import analytics from "../../../../segment";
import events from "../../../../segment/events";

const CustomTab = ({
  country,
  companyId,
}: {
  country: CountryIsoCode;
  companyId: string;
}) => (
  <BenefitCard
    active
    beta
    isCustom
    benefit={BenefitTypeEnum.CUSTOM_BENEFIT}
    title={t("v2.benefits.custom.name")}
    image={customBenefitImage}
    country={country}
    requestedButtonAction={() => {
      analytics.track(events.createCustomBenefit.name, {
        type: events.createCustomBenefit.type,
        companyId,
        country,
      });
      window.location.assign("/v2/benefits/custom-benefits");
    }}
  />
);
export default CustomTab;
